var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.ready)?_c('div',{staticClass:"page-wrapper",class:{'page-wrapper--front' : _vm.isFront}},[_c('router-view'),_vm._v(" "),(!_vm.isFront)?_c('prev-next-nav'):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.ready && !_vm.isFront)?_c('menu-bar'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eada7df0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 